import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useStudent } from "@/lib/auth";

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { setStudent } = useStudent();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(location.hash.replace(/^#/, "")).get("session_id");
    if (!sessionId) {
      navigate("/", { replace: true });
      return;
    }
    api.post("/auth/google/session", { session_id: sessionId })
      .then((r) => {
        setStudent(r.data);
        navigate("/profile", { state: { user: r.data }, replace: true });
      })
      .catch(() => {
        toast.error("Sign-in could not be completed. Please try again.");
        navigate("/", { replace: true });
      });
  }, [location, navigate, setStudent]);

  return (
    <div data-testid="auth-callback" className="min-h-screen bg-navy flex items-center justify-center">
      <p className="font-serif text-2xl text-cream italic">Signing you in…</p>
    </div>
  );
}
